import { FormIPSubnetField } from '@ipfabric/ui-components/FormIPSubnetField/FormIPSubnetField';
import type {
  IPSubnetInputValue,
  IPSubnetInputValueOrDraft,
} from '@ipfabric/ui-components/IPSubnetInput/IPSubnetInput.types';
import { Link } from '@ipfabric/ui-components/Link/Link';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { z } from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';
import { ipCidrListSchemaZ } from '../../utils/validation';

export const RFC_6890_SCOPES = [
  '10.0.0.0/8',
  '100.64.0.0/10',
  '127.0.0.0/8',
  '169.254.0.0/16',
  '172.16.0.0/12',
  '192.168.0.0/16',
];

export const traceScope: FormSnippet<
  DiscoverySettingsObject,
  { traceScope: IPSubnetInputValueOrDraft },
  { traceScope: IPSubnetInputValue }
> = {
  render: ({ form }) => (
    <FormIPSubnetField
      control={form.control}
      name='traceScope'
      label='Trace scope'
      description='For example: 10.0.0.0/8'
      type='cidr'
      link={
        <Link
          renderAs='button'
          onClick={() => {
            form.setValue(
              'traceScope',
              { ips: RFC_6890_SCOPES },
              { shouldDirty: true, shouldTouch: true },
            );
          }}
          size='small'
        >
          Use RFC 6890 scopes
        </Link>
      }
    />
  ),
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.traceScope = {
      ips: model.traceroute?.scope ?? [],
    };
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.traceroute = {
      ...modelDraft.traceroute,
      scope: transformedValues.traceScope.ips,
    };
  },
  schema: z.object({
    traceScope: ipCidrListSchemaZ,
  }),
};
